module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gallery-container",
    attrs: {
      "id": _vm.id
    }
  }, [(_vm.id === 'photos-official') ? _c('div-container', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('a', {
    attrs: {
      "href": _vm.navInstagram.path,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-instagram",
    staticStyle: {
      "font-size": "1.4em",
      "vertical-align": "middle",
      "margin-bottom": "5px"
    }
  }), _vm._v(" / " + _vm._s(_vm.navInstagram.title))])])]) : _c('div-container', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('a', {
    attrs: {
      "href": _vm.navInstagramHashtag.path,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.navInstagramHashtag.title))])])]), _vm._v(" "), _c('div-container', [_c('div-columns', {
    attrs: {
      "column-num": "is-11",
      "padding-top": "1rem"
    }
  }, [_c('div', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.loadMore),
      expression: "loadMore"
    }],
    staticClass: "masonry-container columns is-gapless is-centered is-multiline is-flex-mobile",
    attrs: {
      "id": "masonry-container",
      "infinite-scroll-disabled": "itemsLoading",
      "infinite-scroll-distance": "-1"
    }
  }, [_vm._l((_vm.items), function(item, index) {
    return (index !== 8 || _vm.isDesktop) ? _c('div', {
      staticClass: "column is-4 is-6-mobile",
      attrs: {
        "data-aos": "fade-up",
        "data-aos-once": "true"
      }
    }, [_c('a', {
      attrs: {
        "href": item.url3,
        "target": "_blank"
      },
      on: {
        "click": function ($event) { return _vm.onItemClick($event, item); }
      }
    }, [_c('div', {
      staticClass: "focus-image-wrapper"
    }, [_c('figure', {
      staticClass: "image square",
      style: ([{
        'background-image': 'url(' + (item.image && item.image.path ? item.image.path : (item.type === 'VIDEO' ? item.url2 : item.url)) + ')'
      }, _vm.styleIE])
    })])])]) : _vm._e()
  }), _vm._v(" "), (!_vm.itemsLoading && !_vm.error && _vm.items.length <= 0) ? _c('div', [_c('h3', {
    staticStyle: {
      "padding-top": "3rem",
      "color": "#aaaaaa"
    }
  }, [_vm._v("(not available yet)")])]) : _vm._e()], 2), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "control notification is-danger"
  }, [_c('button', {
    staticClass: "delete",
    on: {
      "click": function($event) {
        _vm.error = undefined
      }
    }
  }), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.error)
    }
  })]) : _vm._e()])], 1), _vm._v(" "), (_vm.id === 'photos-trending') ? _c('div-container', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('h4', {
    staticClass: "button is-primary"
  }, [_c('a', {
    attrs: {
      "href": _vm.navInstagramHashtag.path,
      "target": "_blank"
    }
  }, [_vm._v("View More on Instagram")])])]) : (_vm.id === 'photos-official') ? _c('div-container', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('h4', {
    staticClass: "button is-primary"
  }, [_c('a', {
    attrs: {
      "href": _vm.navInstagram.path,
      "target": "_blank"
    }
  }, [_vm._v("View More on Instagram")])])]) : _c('div-container', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('h4', {
    staticClass: "button is-primary"
  }, [_c('a', {
    attrs: {
      "href": '/photos'
    }
  }, [_vm._v("View All")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fb6324b4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/InstagramSection.vue
// module id = 943
// module chunks = 1